// Firestore collection names
export const USER_COLLECTION = "users";
export const GROUP_COLLECTION = "groups";
export const MESSAGE_COLLECTION = "messages";
export const MENU_ITEM_COLLECTION = "menuItems";

// Junction/relationship collections
export const GROUP_USER_COLLECTION = "jGroupUsers";

// Contact and communication collections
export const EMAIL_ACTIVATION_LOG_COLLECTION = "emailActivationLogs";
export const PHONE_ACTIVATION_LOG_COLLECTION = "phoneActivationLogs";